<template>
    <div class="l-login">
        <div class="l-form">
            <div class="justify-content-center" style="margin-left: 15%;">
                <img src="https://chezagame.com/images/chezagame-logo.png" width="190px" />
            </div>
            <div class="row">
    
                <form @submit.prevent="goToLogin" v-if="!verifyLogin">
                    <div class="col">
                        <h2>Login | ChezaGame</h2>
                        <div v-show="loginStatus">
                            <small class="text-red">{{loginStatusMessage}}</small>
                        </div>
                    </div>
                    <div class="col">
                        <label>Phone number</label>
                        <input type="tel" v-model="msisdn" placeholder="Enter phone number" />
                    </div>
                    <div class="col">
                        <label>Password</label>
                        <input type="password" v-model="password" placeholder="xxxx" />
                    </div>
                    <div class="col">
                        <button id="login" type="submit" class="button primary" block>Login</button>
                    </div>
                    <div class="col">
    
                        <router-link :to="{name: 'forgot'}">Forgot password?</router-link>
    
                    </div>
                </form>
    
                <form @submit.prevent="goToVerifyLogin" v-if="verifyLogin">
                    <div class="col">
                        <h2 style="text-align: center;">OTP | ChezaGame</h2>
    
                    </div>
                    <div class="col">
                        <div class="justify-content-center">
                            <h6 style="text-align: center;">Please enter the one time password <br> to verify your account
                                <span>A code has been sent to</span> <small id="maskedNumber">{{msisdn | maskPhone}}</small>
                            </h6>
                            <p v-if="seconds > 0" style="text-align: center; color: crimson;">Resend code in {{ seconds }}s</p>
    
                            <div v-show="verifyStatus">
                                <small class="text-red" style="text-align: center;">{{verifyStatusMessage}}</small>
                            </div>
                        </div>
                    </div>
    
                    <div class="col">
                        <div id="otp" class="inputs d-flex flex-row justify-content-center mt-2">
                            <input v-for="(digit, index) in otp" class="m-2 text-center form-control rounded" :key="index" v-model="otp[index]" @input="handleInput(index)" @keydown.backspace="handleBackspace(index)" maxlength="1" ref="otpInputs" />
                        </div>
                    </div>
                    <div class="col">
                        <button class="button secondary" v-if="seconds == 0" block @click="goToLogin()" id="resendlogin">Resend Code</button>
                        <button id="verify" type="submit" v-if="seconds > 0" class="button primary">Validate</button>
                    </div>
    
                </form>
    
    
    
            </div>
        </div>
    </div>
</template>

<script>
import store from "../store";
import $ from 'jquery'
export default {
    data: function() {
        return {
            msisdn: '',
            loginStatus: false,
            loginStatusMessage: '',
            verifyStatusMessage: "",
            password: "",
            verification_code: "",
            otp: ['', '', '', '', '', ''],
            verifyLogin: false,
            verifyStatus: false,
            seconds: 60,
            timer: null,
        }
    },
    mounted() {
        this.startCountdown();
    },

    beforeDestroy() {
        clearInterval(this.timer);
    },
    methods: {
        startCountdown() {
            $('#verify').text('Validate')
            this.seconds = 60;
            this.timer = setInterval(() => {
                if (this.seconds > 0) {
                    this.seconds--;
                } else {
                    clearInterval(this.timer);
                    
                }
            }, 1000);
        },
        handleInput(index) {
            if (this.otp[index].length > 1) {
                this.otp[index] = this.otp[index][0];
            }
            if (this.otp[index] !== '' && index < this.otp.length - 1) {
                this.$refs.otpInputs[index + 1].focus();
            }
        },
        handleBackspace(index) {
            if (this.otp[index] === '' && index > 0) {
                this.$refs.otpInputs[index - 1].focus();
            }
        },

        goBackLogin() {
            this.verifyLogin = false
        },
        goToLogin() {
            this.loginStatus = false;
            this.loginStatusMessage = "";
            this.verifyStatus = false;
            this.verifyStatusMessage = ""
            var vm = this;

            $('#login').html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $('#resendlogin').html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/sys/login',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    user_name: vm.msisdn,
                    country_code: "254",
                    user_pass: vm.password
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $('#login').text('Login')
                    $('#resendlogin').text('Resend Code')

                    if (response.data.code == 200) {
                        vm.verifyLogin = true
                        vm.startCountdown()


                    } else {
                        if (response.data.code == 406) {
                            vm.$cookies.set("user_name", vm.msisdn);
                            vm.$router.push({
                                name: 'verify'
                            });
                        } else {
                            vm.loginStatus = true;
                            vm.loginStatusMessage = response.data.message
                        }
                    }

                    // swal("Success!", "Access Granted!", "success");

                },
                error: function(jQxhr, status, error) {
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.loginStatus = true;
                    $('#login').text('Login')
                    $('#resendlogin').text('Resend Code')
                    if (!statustext) {
                        vm.loginStatusMessage = "An error occurred. Try again later.";
                    } else {
                        vm.loginStatusMessage = statustext;;
                    }
                }
            });
        },
        goToVerifyLogin() {
            this.loginStatus = false;
            this.loginStatusMessage = "";
            var vm = this;
            vm.verification_code = this.otp.join('')
            $('#verify').html('<i class="fa fa-spinner fa-spin"></i> Loading...');
            $.post({
                url: store.state.rootUrl + 'portal/v1/sys/verify/login',
                type: "POST",
                headers: {
                    "X-App-Key": "09lib74145Qb3HO6eQTIfsbylRkyuZFT",
                    "X-Authorization-Key": "ADMIN_APP",
                    "X-Requested-With": "XMLHttpRequest",
                    "Content-Type": "application/json"
                },
                data: JSON.stringify({
                    user_name: vm.msisdn,
                    country_code: "254",
                    verification_code: vm.verification_code
                }),
                success: function(response, status, jQxhr) {
                    // console.log(JSON.stringify(response.data.data));
                    $('#verify').text('Validate')
                    if (response.data.code == 200) {
                        vm.$cookies.set("accessToken", response.data.data.token);
                        vm.$cookies.set("role_id", response.data.data.acl_id);
                        console.log("am here " + response.data.data.acl_id)

                        vm.$cookies.set("profileInfo", vm.parseJwt(response.data.data.profile_info));
                        vm.flash('Access Granted!', 'success');
                        if (response.data.data.acl_id == 3) {
                            vm.$router.push({
                                name: 'customers'
                            });
                        } else {
                            vm.$router.push({
                                name: 'dashboard'
                            });
                        }

                    } else {

                        vm.verifyStatus = true;
                        vm.verifyStatusMessage = response.data.message

                    }

                    // swal("Success!", "Access Granted!", "success");

                },
                error: function(jQxhr, status, error) {
                    var statustext = jQxhr.responseJSON.statusDescription;
                    vm.verifyStatus = true;
                    $('#verify').text('Validate')
                    if (!statustext) {
                        vm.verifyStatusMessage = "An error occurred. Try again later.";
                    } else {
                        vm.verifyStatusMessage = jQxhr.responseJSON.data.message;
                    }
                }
            });
        },
        parseJwt(token) {
            var base64Url = token.split('.')[1];
            var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
            var jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            }).join(''));

            return JSON.parse(jsonPayload);
        }
    },
    filters: {
        maskPhone(value) {
            if (!value) return '';
            let str = value.toString();
            return str.length > 6 ? '*'.repeat(6) + str.slice(6) : '*'.repeat(str.length);
        },
    }
}
</script>

<style>
.height-100 {
    height: 100vh
}

.inputs input {
    width: 40px;
    height: 40px
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    margin: 0
}

.card-2 {
    background-color: #fff;
    padding: 10px;
    width: 350px;
    height: 100px;
    bottom: -50px;
    left: 20px;
    position: absolute;
    border-radius: 5px
}

.card-2 .content {
    margin-top: 50px
}

.card-2 .content a {
    color: red
}

.form-control:focus {
    box-shadow: none;
    border: 2px solid red
}

.validate {
    border-radius: 20px;
    height: 40px;
    background-color: red;
    border: 1px solid red;
    width: 140px
}
</style>